<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Pengiriman</a></li>
                <li><a href="#/pengiriman">Data</a></li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-left" style="padding-left: 20px; padding-top: 10px;">
                          <h4><b>DATA PENGIRIMAN</b></h4>
                        </div>
                        <div class="pull-right" style="padding-right: 20px; padding-top: 10px;">
                          <el-date-picker style="width: 140px"
                            v-model="value3"
                            type="date"
                            placeholder="Pilih Tanggal">
                          </el-date-picker>
                          <el-button icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" type="success" @click="getData()"></el-button>
                        </div>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal" border hover
                          :data="tableData1"
                          style="width: 100%" responsive>
                          <el-table-column fixed="left"
                            label="TANGGAL"
                            prop="tanggal"
                            header-align="left"
                            align="left"
                            width="130px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_nama" placeholder="Filter Tanggal" @keyup.native="cariNama()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.tanggal }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="NOMOR"
                            prop="nomor"
                            header-align="left"
                            align="left"
                            width="150px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_nik" placeholder="Filter Nomor" @keyup.native="cariNik()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.nomor }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="TOKO"
                            prop="toko"
                            header-align="left"
                            align="left">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{scope.row.toko}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="ARMADA"
                            prop="armada"
                            min-width="150">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_toko" placeholder="Filter Armada" @keyup.native="cariToko()"></el-input>
                              </template>
                              <span v-else>
                                <a href="#" @click.prevent="gantiArmada(scope.row.nomor,scope.row.toko)" style="width:100%; height:100%;">{{ scope.row.nopol }}</a>
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column fixed="right" label="PILIHAN" align="center" header-align="center" width="100px"> <!--width="150px"-->
                            <template slot-scope="scope">
                              <el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Ok" placement="top-start">
                                <el-button type="success" size="small" icon="el-icon-check"  @click="confirmEdit1(scope.$index, scope.row, ('form' + scope.$index))"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Detail" placement="top-start">
                                <el-button type="primary" size="small" icon="el-icon-search"  @click="detailDO(scope.row.nomor,scope.row.toko)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Cancel" placement="top-start">
                                <el-button size="small" icon="el-icon-error" type="warning" @click="cancelEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <!-- <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Hapus" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-delete" @click="confirmDel(scope.row)"></el-button>
                              </el-tooltip> -->
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <!-- <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData.length"
                            :page-size="page_size"
                            :current-page="current_page"
                            @current-change="handleCurrentChange" >
                          </el-pagination>
                        </div> -->


                    </div>
                </div>

                <el-dialog title="Edit Data" :visible.sync="dialogFormEdit" v-loading="loadingModalEdit" width="500px" top="2%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formEdit" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="NIK" prop="nik">
                      <el-input type="text" v-model="row1.nik"></el-input>
                    </el-form-item>
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="Tgl Lahir" prop="tanggal_lahir">
                      <el-date-picker
                        v-model="row1.tanggal_lahir"
                        type="date">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Alamat" prop="alamat">
                      <el-input type="text" v-model="row1.alamat"></el-input>
                    </el-form-item> -->
                    <el-form-item label="HP" prop="hp">
                      <el-input type="text" v-model="row1.hp"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="Tgl Masuk" prop="tanggal_masuk">
                      <el-date-picker
                        v-model="row1.tanggal_masuk"
                        type="date">
                      </el-date-picker>
                    </el-form-item> -->
                    <el-form-item label="Level" prop="kode_pegawai_level">
                      <el-select v-model="row1.kode_pegawai_level" placeholder="Pilih Level">
                        <el-option
                          v-for="item in region"
                          :key="item.kode"
                          :label="item.nama"
                          :value="item.kode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="Aktif" prop="aktif">
                      <el-select v-model="row1.aktif" placeholder="Pilih Aktif">
                        <el-option
                          v-for="item in aktif"
                          :key="item.kode"
                          :label="item.nama"
                          :value="item.kode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="Bank" prop="kode_bank">
                      <el-select v-model="row1.kode_bank" placeholder="Pilih Bank">
                        <el-option
                          v-for="item in bank"
                          :key="item.kode"
                          :label="item.nama"
                          :value="item.kode">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="Rekening" prop="rekening">
                      <el-input type="text" v-model="row1.rekening" @keyup.enter.native="confirmEdit1(0, row1, 'formEdit')"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel" width="500px" top="2%">
                  <h4>Apakah Anda yakin akan menghapus Pegawai {{ nama }}?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Informasi" :visible.sync="dialogFormInfo" width="500px" top="2%">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>
                <!-- End of Basic Tables-->
                
                <el-dialog :title="this.keterangan" :visible.sync="dialogDetailDO" v-loading="loadingModalDetailDO" width="800px" top="1%">
                  <el-table border hover
                    :data="datado"
                      highlight-current-row
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="BARANG">
                      <template slot-scope="scope">
                          {{scope.row.nama_barang}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="QTY"
                      width="100px">
                      <template slot-scope="scope">
                          {{toMoney(scope.row.qty)}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="SATUAN"
                      width="150px">
                      <template slot-scope="scope">
                          {{scope.row.satuan}}
                      </template>
                    </el-table-column>
                  </el-table>
                  <br />
                  <el-table border hover
                    :data="datakirim"
                      highlight-current-row
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="WAKTU KIRIM">
                      <template slot-scope="scope">
                          {{scope.row.waktu_simpan}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="LOKASI"
                      width="100px">
                      <template slot-scope="scope">
                          <a href="#" @click.prevent="lokasi(scope.row.latt,scope.row.longg)" style="width:100%; height:100%;">klik disini</a>
                      </template>
                    </el-table-column>
                  </el-table>

                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogDetailDO = false">Tutup</el-button>
                    </span>
                </el-dialog>

                <el-dialog :title="this.keterangan" :visible.sync="dialogGantiToko" v-loading="loadingModalGantiToko" width="500px" top="1%">
                  <el-input
                    v-model="cari_toko"
                    placeholder="Cari Toko"
                    @keyup.native="handleSelect"
                  ></el-input>&nbsp;
                  <el-table border hover
                    :data="toko"
                      highlight-current-row
                      @current-change="handleCurrentChangeToko"
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="#"
                      min-width="50">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="NOPOL"
                      min-width="300">
                      <template slot-scope="scope">
                          {{scope.row.nopol}}
                      </template>
                    </el-table-column>
                  </el-table>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogGantiToko = false">Tutup</el-button>
                      <el-button type="primary" @click="simpanArmada()" v-if="level === 'ROOT'">Simpan</el-button>
                    </span>
                </el-dialog>

            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    export default {
      name: 'Wilayah',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          level: localStorage.level,
          value3: new Date(),
          gantiArmadaNomor: '',
          gantiArmadaToko: '',
          gantiArmadaNopol: '',
          aktif: [
            {kode: 'Y', nama: 'Ya'},
            {kode: 'T', nama: 'Tidak'}
          ],
          row1: {kode: '', nama: '', nik: '', alamat: '', hp: '', bank: '', rekening: '', tanggal_lahir: new Date(), tanggal_masuk: new Date(), edit: true},
          tableData: [],
          tableData1: [],
          tableData2: [],
          datado: [],
          datakirim: [],
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          cari_nama: '',
          cari_region: '',
          cari_level: '',
          cari_rekening: '',
          cari_bank: '',
          cari_aktif: '',
          cari_hp: '',
          cari_alamat: '',
          cari_nik: '',
          cari_tanggal_masuk: '',
          cari_tanggal_lahir: '',
          cari_toko: '',
          nama: '',
          region: [],
          bank: [],
          toko: [],
          toko1: [],
          coba: false,
          fullscreenLoading: false,
          dialogFormEdit: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          dialogFormInfo: false,
          loadingModalGantiToko: false,
          dialogGantiToko: false,
          loadingModalDetailDO: false,
          dialogDetailDO: false,
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          formLabelWidth: 'auto',
          rules3: {
            nik: [
              { required: true, message: 'Silahkan isi NIK pegawai', trigger: 'blur' }
            ],
            nama: [
              { required: true, message: 'Silahkan isi nama pegawai', trigger: 'blur' }
            ],
            alamat: [
              { required: true, message: 'Silahkan isi alamat pegawai', trigger: 'blur' }
            ],
            hp: [
              { required: true, message: 'Silahkan isi hp pegawai', trigger: 'blur' }
            ],
            kode_bank: [
              { required: true, message: 'Silahkan isi bank pegawai', trigger: 'change' }
            ],
            rekening: [
              { required: true, message: 'Silahkan isi rekening pegawai', trigger: 'blur' }
            ],
            kode_pegawai_level: [
              { required: true, message: 'Silahkan pilih level pegawai', trigger: 'change' }
            ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Nama A-Z', key: '+nama' }, { label: 'Nama Z-A', key: '-nama' }],
          total: null,
          page_size: 50000,
          current_page: 1
        }
      },
      methods: {
        gantiArmada: function (nomor, toko) {
          this.gantiArmadaNomor = nomor
          this.gantiArmadaToko = toko
          this.dialogGantiToko = true
          this.loadingModalGantiToko = true
          this.keterangan = 'Nomor ' + nomor

          var req = ''
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.armada + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            this.loadingModalGantiToko = false
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.toko = response.body.data
              this.toko1 = this.toko.slice()
            }
          }, response => {
            // error callback
            this.loadingModalGantiToko = false
          })
        },
        lokasi: function (latt, longg) {
          window.open('https://www.latlong.net/c/?lat=' + latt + '&long=' + longg, '_blank', 'location=yes,height=700,width=900,scrollbars=yes,status=yes')
        },
        detailDO: function (nomor, toko) {
          this.dialogDetailDO = true
          this.loadingModalDetailDO = true
          this.keterangan = 'Detail ' + nomor

          var req = {nomor: nomor, toko: toko}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengiriman + '/detailDO'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            this.loadingModalDetailDO = false
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.datado = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalDetailDO = false
          })

          this.loadingModalDetailDO = true
          req = {nomor: nomor, toko: toko}
          req1 = JSON.stringify(req)

          url = Vue.cookie.get('url') + '/' + jsonUrl.pengiriman + '/detailKirim'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            this.loadingModalDetailDO = false
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.datakirim = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalDetailDO = false
          })
        },
        resetForm (formName) {
          if (this.$refs[formName] !== undefined) {
            this.$refs[formName].resetFields()
          }
        },
        clearForm: function () {
          this.row1 = {kode: '', nama: '', edit: true, kode_pegawai_level: '', nik: '', tanggal_lahir: new Date(), alamat: '', hp: '', tanggal_masuk: new Date(), kode_bank: '', rekening: ''}
          this.resetForm('formAdd')
        },
        cariNama () {
          var nama = this.cari_nama
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.tanggal
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariNik () {
          var nama = this.cari_nik
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nomor
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariTanggalLahir () {
          var nama = this.cari_tanggal_lahir + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.tanggal_lahir + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariTanggalMasuk () {
          var nama = this.cari_tanggal_masuk + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.tanggal_masuk + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariLevel () {
          var nama = this.cari_level
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.level
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariBank () {
          var nama = this.cari_bank
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.bank
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariToko () {
          var nama = this.cari_toko
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nopol
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariRekening () {
          var nama = this.cari_rekening
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.rekening
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariAktif () {
          var nama = this.cari_aktif
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.aktif
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariAlamat () {
          var nama = this.cari_alamat
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.alamat
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariHp () {
          var nama = this.cari_hp
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.hp
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nama.toLowerCase()
              var y = b.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nama.toLowerCase()
              var y = a.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        handleSelect: function () {
          var nama = this.cari_toko
          var newArray = this.toko1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nopol
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.toko = newArray1.slice()
        },
        handleCurrentChangeToko (val) {
          this.gantiArmadaNopol = val.nopol
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        confirmDet: function (row) {
          this.$router.push('/area/' + row.kode + '/' + row.nama)
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          this.resetForm('formEdit')
          this.row1.kode = row.kode
          this.row1.nama = row.nama
          this.row1.nik = row.nik
          this.row1.tanggal_lahir = row.tanggal_lahir
          this.row1.tanggal_masuk = row.tanggal_masuk
          this.row1.alamat = row.alamat
          this.row1.hp = row.hp
          this.row1.kode_bank = row.kode_bank
          this.row1.rekening = row.rekening
          this.row1.aktif = row.aktif
          this.row1.kode_pegawai_level = row.kode_pegawai_level + ''
          this.row1.toko = row.toko
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (row.kode !== '') {
                this.loadingModalEdit = true
              } else {
                this.loadingModalAdd = true
              }
              this.dialogFormVisible = false
              this.dialogFormEdit = false

              // var tgl = moment(row.tanggal_lahir).format('YYYY-MM-DD')
              // var tgl1 = moment(row.tanggal_masuk).format('YYYY-MM-DD')

              var req = ''
              var action = '/'
              if (row.kode !== '') {
                req = {kode: row.kode, nama: row.nama, kode_pegawai_level: row.kode_pegawai_level, nik: row.nik, hp: row.hp, aktif: row.aktif, kode_bank: row.kode_bank, rekening: row.rekening}
                action += 'update'
              } else {
                req = {nama: row.nama, kode_pegawai_level: row.kode_pegawai_level, nik: row.nik, hp: row.hp, kode_bank: row.kode_bank, rekening: row.rekening}
                action += 'create'
              }
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.pegawai + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModalAdd = false
                  // this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModalAdd = false
                // this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormWilDel = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pegawai + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        toMoney (x) {
          var parts = x.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return parts.join('.')
        },
        simpanArmada: function () {
          this.loadingModalGantiToko = true
          var req = {nomor: this.gantiArmadaNomor, toko: this.gantiArmadaToko, nopol: this.gantiArmadaNopol}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengiriman + '/updateArmada'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogGantiToko = false
              this.loadingModalGantiToko = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
            }
          }, response => {
            // error callback
            this.dialogGantiToko = false
            this.loadingModalGantiToko = false
          })
          // this.dialogFormWilDel = false
        },
        getData: function () {
          this.fullscreenLoading = true
          this.tableData = []
          this.tableData1 = []
          // var c = this.current_page
          var req = {tanggal: moment(this.value3).format('YYYY-MM-DD')}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengiriman + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.fullscreenLoading = false
              this.loadingModal = false
              this.tableData = response.body.data.slice()
              this.tableData2 = this.tableData.slice()

              this.tableData1.push({kode: '', edit: true, nama: ''})
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData1.push(this.tableData[i])
              }
              // var a = 0
              // var b = a + this.page_size
              // if (b > this.tableData.length) {
              //   b = this.tableData.length
              // }
              // for (var j = a; j < b; j++) {
              //   this.tableData1.push(this.tableData[j])
              // }
              // this.current_page = c
              // this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
            this.fullscreenLoading = false
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.pegawai_level + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.region = response.body.data.slice()
              for (var i = 0; i < this.region.length; i++) {
                this.region[i].kode = this.region[i].kode + ''
              }
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.bank + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.bank = response.body.data.slice()
              for (var i = 0; i < this.bank.length; i++) {
                this.bank[i].kode = this.bank[i].kode + ''
              }
            }
          }, response => {
            // error callback
          })
        }
      },
      mounted () {
        if (localStorage.level !== 'ROOT') {
          this.$router.replace('/toko')
        }
        this.loadingModal = true
        this.getData()
      }
    }
</script>

<style>
  /* .edit-input {
    width: 100%;
    padding-right: 0; 100px;
  } */
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// Pengiriman.vue?6abc1362